import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export default function PyramidChart({ data, height, yAxisLabel }) {
  if (!data || data.length === 0) return null;

  const firstItem = data[0] || {};
  const seriesKeys = Object.keys(firstItem).filter((k) => k !== "label");
  const labels = data.map(item => item.label);

  const leftKey = seriesKeys[0];
  const rightKey = seriesKeys[1];

  const datasets = [];

  if (leftKey) {
    datasets.push({
      label: leftKey,
      data: data.map(item => -Math.abs(item[leftKey] || 0)),
      backgroundColor: "#F25F22",
      borderWidth: 0,
      borderRadius: 6,
      barPercentage: 0.85,
      categoryPercentage: 0.85,
    });
  }

  if (rightKey) {
    datasets.push({
      label: rightKey,
      data: data.map(item => Math.abs(item[rightKey] || 0)),
      backgroundColor: "#262626",
      borderWidth: 0,
      borderRadius: 6,
      barPercentage: 0.85,
      categoryPercentage: 0.85,
    });
  }

  const chartData = {
    labels,
    datasets,
  };

  const options = {
    indexAxis: 'y', // Membuat bar menjadi horizontal
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          font: { size: 12 },
          usePointStyle: false,
          boxWidth: 40,
        }
      },
      tooltip: {
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        titleColor: '#1f2937',
        bodyColor: '#4b5563',
        borderColor: '#e5e7eb',
        borderWidth: 1,
        padding: 10,
        boxPadding: 4,
        callbacks: {
          // Memastikan tooltip menampilkan nilai absolut (positif) meski datanya negatif
          label: (context) => {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            if (context.parsed.x !== null) {
              // Hapus tanda minus
              label += Math.abs(context.parsed.x);
            }
            return label;
          }
        }
      }
    },
    scales: {
      x: {
        stacked: true, // Menyambungkan bar
        grid: {
          color: '#f3f4f6',
        },
        ticks: {
          font: { size: 11 },
          color: '#6b7280',
          // Label X-Axis selalu menampilkan nilai absolut (positif)
          callback: function (value) {
            return Math.abs(value);
          }
        },
        title: {
          display: !!yAxisLabel, // Backend mengirim xAxisTitle tapi di DynamicChart propsnya yAxisLabel (karena rotasi)
          text: yAxisLabel || '',
          color: '#4b5563',
          font: { size: 13, weight: 'bold' },
          padding: { top: 12 }
        }
      },
      y: {
        stacked: true, // Menyambungkan bar
        grid: {
          display: false,
        },
        ticks: {
          font: { size: 11 },
          color: '#6b7280'
        }
      }
    }
  };

  return (
    <div style={{ height: height, width: '100%' }}>
      <Bar options={options} data={chartData} />
    </div>
  );
}
